// Bar Graph
$(function() {
    let Stat_Bar_Graph = {
        init: function(){
            let self = this;

            let chartElement = document.querySelector('#stat-par-graph');

            if(chartElement) {
                this.loadGraph(chartElement);
            }
        },

        loadGraph: function(chartElement) {
            let self = this;

            let context = chartElement.getContext('2d');

            let config = {
                type: 'bar',
                data: {
                    labels: [
                        "Par 3s",
                        "Par 4s",
                        "Par 5s"
                    ],
                    datasets: [{
                        data: [-.3, 1.1,1.3],
                        backgroundColor: [
                            "#008A00",
                            "#D0021B",
                            "#D0021B"
                        ],
                        hoverBackgroundColor: [
                            "#008A00",
                            "#D0021B",
                            "#D0021B"
                        ],
                        barThickness: 60,
                    }]
                },
                options: {
                    legend: {
                        display: false
                    },
                    scales: {

                        xAxes: [{
                            display: false,
                            ticks: {
                                //min: 0
                            },
                        }],
                        yAxes: [{
                            //display: false
                            ticks: {
                                fontColor: '#000000',
                                fontSize: 20,
                                gridLines: {
                                    display: false,
                                    drawBorder: false //<- set this
                                },
                                max: 2,
                                min: -2,
                                minor: {

                                },
                                padding: 10,
                                stepSize: 1,
                                // Customize yAxes tick mark label strings
                                callback: function(value, index, values) {
                                    if(Math.abs(value) % 2 == 1) {
                                        return '';
                                    }
                                    if(value > 0) {
                                        return '+' + value;
                                    }
                                    if(value == 0) {
                                        return 'E';
                                    }

                                    return value;
                                },
                            },
                            gridLines: {
                                borderDash: [5, 5],
                                borderColor: '#cccccc',
                                drawBorder: false,
                                zeroLineBorderDash: [5, 5],
                                zeroLineColor: '#444444',
                                //lineWidth: 0,
                            }
                        }],
                    },
                    maintainAspectRatio: false,
                    scaleShowVerticalLines: false,
                }
            };

            let statBarChart = new Chart(context, config);

            return this;
        }
    }.init();
});